import { HttpClient } from "@utils/index";
import type {
  ExternalRefCapabilityUsageResponse,
  ExternalRefCapabilityUsageViewModel,
} from "@models/monitoring";
import { buildExternalRefCapabilityUsageViewModel } from "@utils/builders/monitoring";

const BASE_URL = import.meta.env.VITE_XPLATFORM_CORE_API_BASE_URL;

if (!BASE_URL) {
  throw new Error(
    "Missing required environment variable: VITE_XPLATFORM_CORE_API_BASE_URL. " +
      "Please check your .env file and ensure the XPlatform Core API URL is set.",
  );
}

/**
 * Cost per capability of one external reference, for the extraction-process and
 * mapping-job detail pages. Everything else (dashboard, monitoring lists, charts)
 * reads core's monitoring BFF through `adminMonitoringApi`.
 */
class CostApi {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(`${BASE_URL}`);
  }

  /** One resource's cost per capability (`extraction_process` / process id, `mapping_job` / job id). */
  async getResourceUsage(refType: string, refId: string): Promise<ExternalRefCapabilityUsageViewModel[]> {
    const url = `/cost-events/external-ref-usage/${encodeURIComponent(refType)}/${encodeURIComponent(refId)}`;
    const response = await this.httpClient.makeAuthenticatedRequest<
      ExternalRefCapabilityUsageResponse[]
    >(url, { method: "GET" });
    return response.map(buildExternalRefCapabilityUsageViewModel);
  }

  async getExternalRefUsageDetail(
    externalRefType: string,
  ): Promise<ExternalRefCapabilityUsageViewModel[]> {
    const url = `/cost-events/external-ref-usage/${encodeURIComponent(externalRefType)}`;
    const response = await this.httpClient.makeAuthenticatedRequest<
      ExternalRefCapabilityUsageResponse[]
    >(url, { method: "GET" });
    return response.map(buildExternalRefCapabilityUsageViewModel);
  }
}

export { CostApi };
export const costApi = new CostApi();
